import React, { useEffect } from 'react';
import { Button } from '@amzn/stencil-react-components/button';
import { useNavigate } from 'react-router-dom';
import { H1 } from '@amzn/stencil-react-components/text';
import { useTranslation } from 'react-i18next';
import { Flex, Spacer } from '@amzn/stencil-react-components/layout';
import { FeedbackLoader } from '../shared/FeedbackLoader';
import { metricSender } from '../../util/metric_sender';
import { useGlobalContext, useUserDataContext } from '../../hooks';

interface FeedbackSummaryProps {
  feedbackCategories: string[]; // feedback categories to retrieve from the backend. e.g. ['Safety']
  title: string, // title to display at the top of the page
  subtitle: string, // subtitle that describes the types of feedbacks being displayed
  metricName: string, // name of the metric to emit when the summary is accessed
}

export const FeedbackSummary = (props: FeedbackSummaryProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { areMetricsSendable, spprSummaries, sqprSummaries } = useUserDataContext();
  const { userDetails } = useGlobalContext();

  useEffect(() => {
    if (areMetricsSendable) {
      metricSender.generateCompetenciesMetrics(
        userDetails,
        spprSummaries,
        sqprSummaries,
        props.metricName,
      );
    }
  }, [areMetricsSendable]);

  return(
    <>
      <Flex flexDirection="row" justifyContent="space-between">
        <H1>{t(props.title)}</H1>
        <Button data-cy="home-btn" onClick={()=>{navigate('/')}}>{t('home')}</Button>
      </Flex>

      <Spacer height={32}/>

      <FeedbackLoader feedbackCategories={props.feedbackCategories} subtitle={props.subtitle} />
    </>
  );
}
